import moment from 'moment';

const isMatchingDateFormat = (value, format) => moment(value, format, true).isValid();

export default isMatchingDateFormat;
